export default __webpack_public_path__ + "static/O0232-3aaecae7c496850ba90a5334d0f6f34e.png";